"use client";
import { DEMO_MODE, demoKeywords } from "@/lib/demo";


import React from "react";
import {InstantSearch} from "react-instantsearch";
import {instantMeiliSearch, InstantMeiliSearchInstance} from "@meilisearch/instant-meilisearch";
import Link from "next/link";

import {AutoComplete, Input} from 'antd';
import type {AutoCompleteProps} from 'antd';
import {useRouter} from "next/navigation";

const {searchClient} = DEMO_MODE ? { searchClient: { search: async (requests: any[]) => ({ results: requests.map(request => ({ hits: demoKeywords.filter(keyword => keyword.includes(request.params?.query || "")).map(keyword => ({ keyword })), nbHits: demoKeywords.length, page: 0, nbPages: 1, hitsPerPage: 10, processingTimeMS: 0, query: request.params?.query || "" })) }) } as any } : instantMeiliSearch(
    process.env.NEXT_PUBLIC_MEILISEARCH_BASE_URL || "",
    process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY,
);

const keysIndexName = `keywords-newgen`;

const replacements = {
    '_1': ':',
    '_2': '/',
    '_3': '?',
    '_4': '&',
    '_5': '=',
    '_6': '.',
    '_7': ',',
    '_8': '#',
    '_9': ' ',
    '_a1': '%',
    '_a2': '@'
}

function CustomSearchBox({
    searchClient,
}: {
    searchClient: InstantMeiliSearchInstance;
}) {
    const router = useRouter()

    const [options, setOptions] = React.useState<AutoCompleteProps['options']>([]);

    const handleSearch = async (value: string) => {
        if (!value || value.includes('@')) {
            setOptions([]); // Clear options if input is invalid
            return;
        }

        // Fetch search results asynchronously
        try {
            const searchResult: any = await Promise.any([
                searchClient
                    .search([
                        {
                            indexName: keysIndexName,
                            params: {
                                query: value,
                                hitsPerPage: 10
                            },
                        },
                    ])
                    .then(({results}) => results[0])
            ]);

            const hits = searchResult.hits;

            // Update state synchronously after fetching data
            setOptions(
                hits.map(({keyword}: any) => {
                    Object.entries(replacements).forEach(([key, rep]) => {
                        keyword = keyword.replaceAll(key, rep);
                    })

                    return {
                        label: <Hit value={keyword} />,
                        value: keyword,
                    }
                })
            );

        } catch (error) {
            console.error("No search results found:", error);
            setOptions([]); // Set empty options if search fails
        }
    };


    const onSelect = (value: string) => {
        // Object.entries(replacements).forEach(([key, rep]) => {
        //     value = value.replaceAll(key, rep);
        // })

        router.push(`/media/${value}/detail`)
    };

    return (
        <AutoComplete
            className="w-full"
            onSearch={handleSearch}
            onSelect={onSelect}
            // size="large"
            // placeholder="input here"
            options={options}
        >
            <Input.Search size="large" placeholder="Cari kata kunci..." enterButton />
        </AutoComplete>
    );
}

interface HitProps {
    value: string;
}

const Hit = ({value}: HitProps) => {
    // Object.entries(replacements).forEach(([key, rep]) => {
    //     value = value.replaceAll(key, rep);
    // })

    return (
        <Link href={`/media/${value}/detail`}>
            <div
                className="w-full py-1 px-4 flex justify-between"
            >
                <p className="text-left truncate text-ellipsis">{value}</p>
            </div>
        </Link>
    );
};


export function SearchAutocomplete() {
    return (
        <div className="w-full">
            <InstantSearch
                indexName={keysIndexName}
                searchClient={searchClient}
                future={{
                    preserveSharedStateOnUnmount: true,
                }}
            >
                <CustomSearchBox searchClient={searchClient} />
            </InstantSearch>
        </div>
    );
}
